import { render, staticRenderFns } from "./Dashboard.admin.vue?vue&type=template&id=7e9437ab&scoped=true&"
import script from "./Dashboard.admin.vue?vue&type=script&lang=js&"
export * from "./Dashboard.admin.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.admin.vue?vue&type=style&index=0&id=7e9437ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9437ab",
  null
  
)

export default component.exports